import { createAction } from '@reduxjs/toolkit'
import {
  Break,
  JobsPayload,
  SecurityMappingFilter,
} from '../focused/focused.models'
import { ExternalFileFilter } from './../focused/focused.models'

/**
 * Show details of a break
 *   - pulls metadata from the break and sets redux focus on that item (depending on the type of break)
 *   - focuses the appropriate panel for the break, which should also be showing details of that focused item
 */
export const showBreakDetailsAction = createAction<Break>(
  '[Breaks] Show Details',
)

/**
 * Highlight jobs in jobs panel
 *   - Sets redux focus on that jobId
 *   - focuses the appropriate panel, which should also be highlighting job
 */
export const showJobsAction = createAction<JobsPayload>('[Jobs] Show Jobs')
/**

/**
 * Request to Focus a panel, or open/focus if not already in the layout
 * Not to be confused with setFocusedUIComponent, which happens after-the-fact
 *
 * @param panelKey for the panel that should be focused
 */
export const focusPanelAction = createAction<string>('[Panels] Focus Panel')

/**
 * Show details of a raw data file
 *   - pulls filter from transaction/position panel and sets redux focus on that item (depending on the type of filter)
 *   - focuses the external file panel , which should also be showing details of that focused item
 */
export const showRawDataAction = createAction<ExternalFileFilter>(
  '[External] File Panel',
)

export const securityMappingAction = createAction<SecurityMappingFilter>(
  '[Security] Mapping Panel',
)

/**
 * Open the bulk transactions panels for bulk editing of breaks
 *   - pulls metadata from the selected breaks and sets redux focus on that item (depending on the type of break)
 *   - focuses the bulk transactions panel for the breaks, which should also be showing transactions of that focused item under the same ultimate parent
 */
export const breaksBulkEditAction = createAction<Break[]>('[Breaks] Bulk Edit')

/**
 * Focuses the multi-breaks panel and fetches data as requested in this action.
 */
export const loadBreaksAction = createAction<{
  type: 'accountIds' | 'breakIds'
  ids: number[] | string[]
}>('[Breaks] Find Breaks')
